module.exports = __webpack_public_path__ + "static/img/DIYStep1.2e357849.jpg";